export default __webpack_public_path__ + "static/img-projects-03-thumb-801ea2a2718f2b44e38b99930ed1a5cc.png";